/**
 * @module navigation
 */
;(function Navigation() {
    /**
     * Handle navigation
     * @param $dom {String} $dom identifier
     * @method navigation
     */
    function navigation($dom) {
        /**
         * // local object availability
         * @type {navigation}
         * @private
         */
        var _this = this

        /**
         * @method cacheDom
         *  assign {jQuery|HTMLElement(s)} to object
         */
        this.cacheDom = function () {
            this.$body = $('body')
            this.$header = $("[data-html-element='header']")
            this.$toggleButton = $dom.find("[data-js='navigation-toggle-button']")
            this.$subMenuCTA = $dom.find("[data-js='nav-sub']")
            this.$subMenuCTABack = $dom.find("[data-js='nav-sub-back']")
            this.$mobileNavigationOverlayMask = $("[data-js='mobile-navigation-overlay-mask']")
            this.$window = $(window)
        }

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.cacheDom()
            _this.render()
        }

        /**
         * @method render
         * @return {undefined}
         */
        this.render = function () {
            _this.bindEvents()
        }

        /**
         * @method bindEvents
         * @return {undefined}
         */
        this.bindEvents = function () {
            _this.$toggleButton.click(function () {
                _this.$body.toggleClass('show-responsive-nav')
            })

            _this.$mobileNavigationOverlayMask.click(function () {
                _this.$body.toggleClass('show-responsive-nav')
            })

            _this.$subMenuCTA.click(function () {
                var submenu = $(this).parent().find('> .main-nav--sub')
                submenu.addClass('visible')
            })

            _this.$subMenuCTABack.click(function () {
                $(this).closest('.main-nav--sub').removeClass('visible')
            })
        }

        /**
         * initialize call navigation
         */
        _this.init()
    }

    // define the global scope
    if (!window.Creaton) {
        window.Creaton = {}
    }

    window.Creaton.navigation = navigation
})()

$(document).ready(function () {
    var $navigation = $("[data-html-element='main-nav-container']")
    new window.Creaton.navigation($($navigation))
})
